/**
 * Tab is a button that triggers its associated TabPanel to be displayed
 */
import React, { ReactNode, createRef, Component, MouseEvent } from "react";
import classNames from "classnames";
import { handleMouseUpByBlurring } from "../../../utils/focus";
import { TabsContext } from "./Tabs";

export interface ITabProps {
  children: ReactNode;
  index?: number;
  className?: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
}

class Tab extends Component<ITabProps> {
  public static contextType = TabsContext;
  private tabRef = createRef<HTMLButtonElement>();

  public componentDidMount(): void {
    this.context.addTabRef(this.tabRef, this.props.index);
  }

  public componentWillUnmount(): void {
    this.context.removeTabRef(this.tabRef);
  }

  render(): ReactNode {
    const { index, children, className, onClick } = this.props;
    const { selectedIndex, setSelectedIndex, id } = this.context;
    const isSelected = selectedIndex === this.props.index;

    const handleClick = (event: MouseEvent<HTMLButtonElement>): void => {
      onClick?.(event);
      setSelectedIndex(index);
    };

    return (
      <button
        className={classNames("tabs__tab", className)}
        role="tab"
        aria-selected={isSelected}
        aria-controls={`tabs-${id}-panel-${index}`}
        id={`tabs-${id}-tab-${index}`}
        onClick={handleClick}
        onMouseUp={handleMouseUpByBlurring}
        tabIndex={isSelected ? 0 : -1}
        ref={this.tabRef}
      >
        {children}
      </button>
    );
  }
}

export default Tab;
